export default "__VITE_ASSET__iPk5yfbD__"